import { Food } from "./food.model";
import { safeFind } from 'src/app/utils';

export class  Recipe {

  public foods: any[];
  public ingredients: any[];
  public portions: number;
  public status: "active" | "archived";
  public title: string;
  public uid: string;
  public photo: string;
  public description: string;
  public lastModifiedBy:string;
  public lastModifiedDate:string;
  public organization?: string;
  public instructions?: string[];
  
  constructor (init: Partial<Recipe>){
      Object.assign(this, init);
  }

  getFoods(): string[] {
    const toReturn = [];
    if(this.foods && this.foods.length > 0) {
      for (const foodObj of this.foods) {
        const index = toReturn.indexOf(foodObj.food);
        if(index === -1) {
          toReturn.push(foodObj.food);
        }
      }
    }
    return toReturn;
  }

  getMacro(macro: string, quantity: number, foods: Food[]) {
    let macroTotal = 0;
    if(this.foods) {
      for (const foodObj of this.foods) {
        const food: Food = safeFind(foods, f => f.$id === foodObj.food);
        if(food && foodObj.quantity) {
          macroTotal += food.getMacro(macro, foodObj.quantity);
        }
      }
    }
    return macroTotal > 0? macroTotal / this.portions * quantity : macroTotal
  }
}